import React from "react";
import styled from "styled-components";
import LogoPng from "../../img/LOGO.png"
import KCPPng from "../../img/KCP.png"


const Styled={
    Wrap:styled.div`
        width:100%;
        height:547px;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
    `,
        ContentsWrap:styled.div`
            width:88.8%;
            height:389px;
            display:flex;
            justify-content:space-between;
            align-items:flex-start;
            flex-direction:column;
        `,
            Logo:styled.div`
                width:83.1px;
                height:20px;
            `,
                LogoImg:styled.img`
                    width:100%;
                    height:100%;
                `,
            InfoWrap:styled.div`
                width:100%;
                height:170px;
                display:flex;
                justify-content:space-between;
                align-items:flex-start;
                flex-direction:column;
            `,
                InfoText:styled.p`
                    font-size:14px;
                    font-weight:400;
                    margin:0px;
                    font-family:'PreFont';
                    color:#767676;
                    line-height:140%;
                    letter-spacing:-0.33px;
                `,
            PersonalInfo:styled.p`
                font-size:16px;
                font-weight:600;
                margin:0px;
                font-family:'PreFont';
                line-height:140%;
                letter-spacing:-0.33px;
                color:#767676;
            `,
            Copyright:styled.p`
                font-size:14px;
                font-weight:600;
                margin:0px;
                font-family:'PreFont'
                line-height:140%;
                letter-spacing:-0.33px;
                color:#767676;
            `,
            KCPBtn:styled.div`
                width:65px;
                height:63px;
            `,
                KCPIMG:styled.img`
                    width:100%;
                    height:100%;
                `,  
}

const CompanyInfo=()=>{
    return(
        <Styled.Wrap>
            <Styled.ContentsWrap>
                <Styled.Logo>
                    <Styled.LogoImg src={LogoPng}/>
                </Styled.Logo>
                <Styled.InfoWrap>
                    <Styled.InfoText>대표(개인정보관리책임자) : 김도윤</Styled.InfoText>
                    <Styled.InfoText>사업자등록번호 : 427-88-03743</Styled.InfoText>
                    <Styled.InfoText>통신판매업 신고번호 : 2025-수원장안-0196</Styled.InfoText>
                    <Styled.InfoText>호스팅제공자 : 트리펙트</Styled.InfoText>
                    <Styled.InfoText>상호명 : 트리펙트</Styled.InfoText>
                    <Styled.InfoText>사업장소재지 : 수원시 장안구 덕영대로 535번길 67</Styled.InfoText>
                    <Styled.InfoText>고객센터 : 070-4001-9061</Styled.InfoText>
                    <Styled.InfoText>대표 이메일 : trifect2025@gmail.com</Styled.InfoText>
                </Styled.InfoWrap>
                <Styled.PersonalInfo 
                    onClick={() => window.open("https://zzikgomainpage.netlify.app/personal/rule", "_blank")} 
                    style={{ cursor: "pointer" }}>
                    이용약관
                </Styled.PersonalInfo> 
                <Styled.PersonalInfo 
                    onClick={() => window.open("https://zzikgomainpage.netlify.app/personal/personalinfo", "_blank")} 
                    style={{ cursor: "pointer" }}>
                    개인정보 처리방침
                </Styled.PersonalInfo>    
            
                <Styled.Copyright>© Copyright 2024 QTING . All rights reserved.</Styled.Copyright>
                <Styled.KCPBtn>
                    <Styled.KCPIMG src={KCPPng}/>
                </Styled.KCPBtn>
            </Styled.ContentsWrap>
        </Styled.Wrap>
    )
}
export default CompanyInfo 